import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    errorMsg: { margin: 0 },
    error: { color: theme.palette?.text?.errorRed || '#B00020' },
    success: { color: theme.palette?.text?.successBoxBorder || '#00C48C' },
    warning: { color: theme.palette?.text?.warningBorder || '#F18D5A' },
    info: { color: theme.palette?.text?.primary || '#4086ff' },
}));
